package fr.frux.feature.treedetail.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import fr.frux.core.designsystem.icons.FruxIcons
import fr.frux.core.designsystem.theme.fruxColors

/**
 * Remplace la mini-carte de la fiche arbre tant qu'elle n'est pas activée (cf. `MapPreviewSection`
 * dans `TreeDetailScreen`) : même boîte et mêmes actions superposées, sans aucun appel MapLibre —
 * juste un fond neutre et l'épingle, pour que le défilement en haut de la fiche ne coûte rien
 * avant que la carte soit vraiment visible (mesuré sur web : le préchargement de la `LazyColumn`
 * instanciait MapLibre pendant le scroll).
 */
@Composable
fun MapPreviewPlaceholder(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier =
            modifier
                .background(MaterialTheme.colorScheme.surfaceVariant)
                .clickable(onClick = onClick)
                .testTag("mapPreviewPlaceholder"),
        contentAlignment = Alignment.Center,
    ) {
        Icon(
            imageVector = FruxIcons.LocationOn,
            contentDescription = null,
            tint = MaterialTheme.fruxColors.accent,
            modifier = Modifier.size(32.dp),
        )
    }
}
